const singleGoods = [
  {
    path: '/single-info',
    name: 'SingleInfo',
    component: () => import('@/views/wxapp/single-goods/index.vue'),
    meta: {
      title: '商品首页'
    }
  },
  {
    path: '/single-goods',
    name: 'SingleGoods',
    component: () => import('@/views/wxapp/single-goods/single-goods.vue'),
    meta: {
      title: '商品首页'
    }
  },
  {
    path: '/no-goods',
    name: 'NoGoods',
    component: () => import('@/views/wxapp/single-goods/no-goods.vue'),
    meta: {
      title: '商品首页'
    }
  },
  {
    path: '/place-order',
    name: 'PlaceOrder',
    component: () => import('@/views/wxapp/single-goods/place-order.vue'),
    meta: {
      title: '商品下订'
    }
  },
  {
    path: '/pay-detail',
    name: 'NoProduct',
    component: () => import('@/views/wxapp/single-goods/pay-detail.vue'),
    meta: {
      title: '支付详情'
    }
  }
]
export default singleGoods
